module.exports = __webpack_public_path__ + "img/data_tool_help.1d0c4bae.svg";